import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import {
  accountIdFormat,
  locationIdFormat,
  productIdFormat,
  storageLocationIdFormat,
} from "../../ids";

export enum ReplenishmentRequestStatus {
  PENDING = "pending",
  DISMISSED = "dismissed",
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
  FAILED = "failed",
}

export const ReplenishmentRequestStatusSchema = createEnum(
  ReplenishmentRequestStatus,
);

const ReplenishmentRequestSchema_ = z.object({
  id: z.string(),
  accountId: accountIdFormat.schema,
  locationId: locationIdFormat.schema,
  storageLocationId: storageLocationIdFormat.schema,
  productId: productIdFormat.schema,
  pickSessionId: z.string(),
  pickerLegacyUserId: z.string(),
  status: ReplenishmentRequestStatusSchema,
  sourceStorageLocationId: storageLocationIdFormat.schema.nullable(),
  dismissedByLegacyUserId: z.string().nullable(),
  dismissedAt: z.date().nullable(),
  transferSessionId: z.string().nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const ReplenishmentRequestSchema: z.ZodType<ReplenishmentRequest> =
  ReplenishmentRequestSchema_;
export interface ReplenishmentRequest
  extends z.infer<typeof ReplenishmentRequestSchema_> {}

/**
 * When a bin's inventory drops to this ratio of max_quantity or below,
 * a replenishment request is automatically created.
 */
export const REPLENISHMENT_THRESHOLD_RATIO = 0.2;
